<template>
  <v-dialog v-model="showDialog" max-width="450">
    <RescheduleTasksForm
      v-if="showDialog"
      :loading="loading"
      @close="showDialog = false"
      @submit="$emit('submit', $event)"
    />
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { DialogMixin } from '@/bundles/Dialogs/mixins/DialogMixin';

import RescheduleTasksForm from '@/bundles/Tasks/components/RescheduleTasksForm.vue';

export default defineComponent({
  name: 'RescheduleTasksDialog',

  components: { RescheduleTasksForm },
  mixins: [DialogMixin],

  props: {
    loading: Boolean,
  },

  emits: ['submit'],

});
</script>
